export default "__VITE_ASSET__wqxzx$SV__"